import { IResourceComponentsProps } from "@refinedev/core";
import { AntdShowInferencer } from "@refinedev/inferencer/antd";
import Cw8Show from "components/cw8/Cw8Show";

export const SeccionInfografiasShow: React.FC<IResourceComponentsProps> = () => {
  const resourceName :string = 'seccionInfografia';
  return (
    <Cw8Show
      resourceName = {resourceName}
    ></Cw8Show>
  );       
};
